import { render, staticRenderFns } from "./news_student_list.vue?vue&type=template&id=5255c569&scoped=true&"
import script from "./news_student_list.vue?vue&type=script&lang=js&"
export * from "./news_student_list.vue?vue&type=script&lang=js&"
import style0 from "./news_student_list.vue?vue&type=style&index=0&id=5255c569&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5255c569",
  null
  
)

export default component.exports